module.exports = __webpack_public_path__ + "static/media/atomic.3738c939.png";